import {TranslationKeyProps} from 'shared/util/translated-props';
import {SectionProps} from '../components/section';

export const getSection =
  <T>(
    data: Omit<SectionProps<T>, 'type' | 'translationKey'> & {
      translationKey?: TranslationKeyProps;
    },
  ) =>
  (): SectionProps<T> => ({
    ...data,
    translationKey: data.translationKey!,
    type: 'section',
  });
